module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_5.16e2def5.png";